import { createEmspBoCpoSlice } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/emsp-bo-cpo.slice';

import { emspBoCpoApi } from './emsp-bo-cpo.service';

export const emspBoCpoSlice = createEmspBoCpoSlice({ emspBoCpoApi });
